<template>
  <div class="container">
    <content-template>
      <template slot="left">{{activity.name}}</template>
      <template slot="right">
        <li>
          <router-link :to="{path:'activity-rules',query: {id:activity.id}}">簡介及比賽規章</router-link>
        </li>
        <li>
          <router-link :to="{path:'online-enroll',query:{id:activity.id}}">線上報名</router-link>
        </li>
        <li>
          <router-link class="is-check" style="color: #5571EC;" :to="{path:'activity-works',query:{id:activity.id}}">比賽作品</router-link>
        </li>
      </template>
      <template slot="banner">
        <div class="col-xs-12 none-padding" style="text-align: center;">
          <img :src="activity.banner_url" style="padding:0px; max-height: 350px; max-width: 100%;" alt="">
        </div>
      </template>
      <template slot="content" v-if="!isSuccess">
        <span class="news-title">比賽作品</span>
        <div class="transverse-line"></div>
        <span class="work-name">{{workName}}</span>
        <div class="col-xs-12 col-sm-10 col-sm-offset-1 " style="margin-top: 20px">
          <!-- <router-link :to="{path: 'activity-work/1', query: {id:1}}"> -->
          <div class="col-xs-12 work-img">
            <!--************判断是作品的类别*************-->
            <div v-if="file_type == 1">
              <template v-if="work.file.value">
                <img :src="work.file.value" alt="">
              </template>
              <template v-else>
                <img src="@/assets/thumbnail.png">
              </template>
            </div>
            <div v-else-if="file_type == 2">
              <iframe :src="videoUrl" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
            <div v-else-if="file_type == 3">
              <a target="_blank" :href="work.file.value">下載</a>
            </div>
            <div v-else>
              <!--这是文字-->
              <div v-html="work.file.value">
              </div>
            </div>
          </div>

        </div>

        <div class="work-left col-sm-6 col-sm-offset-1">
          <!--<div>-->
          <span>發佈時間：{{work.release_time}}</span><br>
            <template v-for="(value) in work.value">
              <span>{{value.name}} : {{value.value}}</span><br>
            </template>

          <!--</div>-->
        </div>
        <div class="work-right col-sm-5">
          <span class="work-yes"></span>
          <span class="work-votes">{{work.vote_count}}票</span>
          <!--<template v-if="activity.vote_start_time < nowTime && activity.vote_end_time > nowTime ">-->
            <div v-if="voteTime" class="likes" @click="showAlert">
              <label class="heart"></label>
              <span>投票</span>
            </div>
          <!--</template>-->
          <!--<template v-else-if="activity.vote_start_time > nowTime">-->
            <!--<div class="likes">-->
              <!--<label class="heart"></label>-->
              <!--<span style="margin-left: 0px">投票未开始</span>-->
            <!--</div>-->
          <!--</template>-->
          <!--<template v-else>-->
            <!--<div class="likes">-->
              <!--<label class="heart"></label>-->
              <!--<span style="margin-left: 0px">投票已结束</span>-->
            <!--</div>-->
          <!--</template>-->
        </div>
        <template v-if="work">
          <message-code v-on:voteSuccess="isVoteSuccess" ref="alert"></message-code>
        </template>
      </template>
      <template slot="content" v-if="isSuccess">
        <div class="enroll-success">
          投票成功 <br>
          <button @click="goBack">返回</button>
        </div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'
import Vue from 'vue'
import messageCode from '../activity/messageCode.vue'
export default {
  components: {
    'content-template': contentTemplate,
    'message-code': messageCode
  },
  data () {
    return {
      activity: [], // 活动
      work: [],    // 参赛作品
      isSuccess: false,
      file_type: '',  // 作品类型
      workName: '',
      nowTime: 0,
      voteTime: 0,
      videoUrl: ''      // 视频链接
    }
  },
  methods: {
    getWork: function () {
      var that = this
      var id = this.$route.query.id
      var url = 'activity/work/' + id
      this.$axios.get(url)
        .then(function (response) {
          if (response.data.code === 1) {
            that.work = response.data.data
            that.file_type = that.work.file['type_id']
            // 将第一个值赋值给workname
            that.workName = that.work.value[0].value
            that.videoUrl = 'https://www.youtube.com/embed/' + that.work.youtube_id;
            // 删除第一个值
            Vue.delete(that.work.value, '0')
            // console.log('11',that.work)
            that.getActivity(that.work.activity_id)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 根据活动id获取活动
    getActivity: function (id) {
      var that = this
      this.$axios.get('/activity/' + id)
        .then(function (response) {
          that.activity = response.data.data

          that.voteTime = that.activity.vote_start_time < that.nowTime && that.activity.vote_end_time > that.nowTime ? 1 : 0
          // console.log(that.activity)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showAlert: function () {
      if (this.voteTime) {
        const workId = this.work.id
        const activityId = this.work.activity_id
        this.$refs.alert.show(workId, activityId)
      }
    },
    isVoteSuccess: function (voteSuccess) {
      this.isSuccess = voteSuccess
      var that = this
      setTimeout (function () {
        that.$router.push({name: 'activity-works', query: {id: that.activity.id}})
      }, 5000)
    },
    goBack: function () {
      var that = this
      this.$router.push({name: 'activity-works', query: {id: that.activity.id}})
    }
  },
  created: function () {
    var nowTime = Date.parse(new Date()).toString()
    this.nowTime = nowTime.substr(0, 10)
    this.getWork()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }

  .work-file {
    padding: 0px;
    min-height: 400px;
    margin-bottom: 30px;
  }

  .work-img {
    padding: 0px;
    min-height: 400px;
    margin-bottom: 30px;
  }

  .work-img img {
    width: 100%;
  }
  .work-img iframe{
    width: 100%;
    min-height: 400px;
  }

  .work-left,.work-right{
    margin-bottom: 20px;
  }
  .work-left {
    font-size: 16px;
    color: #565656;
  }

  .work-yes {
    display: inline-block;
    width: 23px;
    height: 23px;
    margin-left: 20px;
    margin-right: 5px;
    background: url('yes.png') no-repeat;
    background-size: 23px 23px;
    background-position: 40%;
  }

  .work-votes {
    font-size: 32px;
    color: #617BE4;
  }
  .work-name{
    margin-left:135px;
    font-size:26px;
  }

  .likes {
    position: relative;
    margin-top: 15px;
    margin-left: 30px;
    width: 140px;
    height: 45px;
    border: 2px solid #526ADD;
    border-radius: 100px;
    cursor: pointer;
  }

  .likes span {

    display: inline-block;
    font-size: 20px;
    color: #526ADD;
    margin-left: 55px;
    margin-top: 7px;
    /*margin-bottom: 10px;*/
  }

  .heart {
    position: absolute;
    top: 3px;
    display: inline-block;
    margin-bottom: -10px;
    margin-left: 5px;
    background: #526ADD url('heart.png') no-repeat;
    background-size: 25px 20px;
    background-position: center;
    width: 35px;
    height: 35px;
    border-radius: 35px;
    cursor: pointer;
  }

  @media (max-width: 767px) {
    .work-img {
      z-index: 1;
      padding: 0px;
      min-height: 200px;
    }

    .work-img iframe{
      min-height: 200px;
    }
    .work-left {
      font-size: 12px;
    }

    .work-right {
      margin-top: 10px;
    }

    .work-yes {
      width: 17px;
      height: 17px;
      margin-left: 20px;
      margin-right: 5px;
      background-size: 17px 17px;
      background-position: 40%;
    }

    .work-votes {
      font-size: 20px;
    }

    .likes {
      display: inline-block;
      margin-top: 0px;
      width: 120px;
      height: 40px;
      border: 2px solid #526ADD;
      border-radius: 100px;

    }

    .likes span {
      display: inline-block;
      font-size: 16px;
      color: #526ADD;
      margin-left: 50px;
      /*margin-bottom: 10px;*/
    }

    .heart {
      top: 3px;
      display: inline-block;
      margin-left: 5px;
      background: #526ADD url('heart.png') no-repeat;
      background-size: 20px 15px;
      background-position: center;
      width: 30px;
      height: 30px;
      border-radius: 30px;
    }

    .work-name{
      margin-left:80px;
      font-size:20px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/activity/worksDetail.vue